import React, { useEffect, useState } from 'react';
import feather from 'feather-icons';
import { cardColorClass } from '../../config/design.config';
import SingleCard from './SingleCard';
import AddCard from '../Modals/AddCard';
import SuccessToast from '../../toast/SuccessToast';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

function CardList({ cards, onCardAdd, deleteCard }) {
    const { t } = useLanguage();
    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);

    const handleShow = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    useEffect(() => {
        feather.replace();
    }, []);

    return (
        <>
            <section className="section-b-space">
                <div className="custom-container">
                    <ul className="card-list">
                        <>
                            {cards?.length === 0 && (
                                <>
                                    <div className="empty-page">
                                        <img
                                            className="notification-img custom-img-fluid transaction-icon"
                                            src={'/assets/images/svg/empty-v2.svg'}
                                            alt="notification"
                                        />
                                        <h3 className="d-block fw-normal dark-text text-center mt-3">
                                            {t('noCardAdded')}
                                            <p>{t('youHaventAdded')}</p>
                                        </h3>
                                        <Link
                                            to="#"
                                            onClick={handleShow}
                                            className="btn theme-btn successfully w-100 custom-bottom"
                                        >
                                            {t('addCard')}
                                        </Link>
                                    </div>
                                </>
                            )}
                        </>

                        {cards.map((card) => (
                            <li
                                key={card.id}
                                className={`credit-card-box ${cardColorClass[card?.id % 3]}`}
                            >
                                <SingleCard
                                    card={card}
                                    onCardAdd={onCardAdd}
                                    deleteCard={deleteCard}
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
            {showModal && (
                <AddCard
                    show={showModal}
                    onClose={handleClose}
                    setShowToast={setShowToast}
                    onCardAdd={onCardAdd}
                />
            )}

            {showToast && (
                <SuccessToast message={t('cardAdded')} onClose={() => setShowToast(false)} />
            )}
        </>
    );
}

export default CardList;
